import CreateNewEmployeeApi from "./CreateNewEmployeeApi";

export default CreateNewEmployeeApi;